module.exports = __webpack_public_path__ + "assets/img/llsj2.4c8bb579.png";